import React from 'react';
import { tabs, tab } from 'styles/mobile';

interface Props<T extends string> {
  items: readonly T[];
  value: T;
  onChange: (value: T) => void;
}

function MobileTabs<T extends string>({ items, value, onChange }: Props<T>) {
  return (
    <div css={tabs} role="tablist">
      {items.map((item) => (
        <button
          key={item}
          type="button"
          role="tab"
          aria-selected={item === value}
          css={tab(item === value)}
          onClick={() => onChange(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}

export default MobileTabs;
